import { useForm } from "@inertiajs/react";
import PageHeader from "@/components/PageHeader";
import TabNavigation from "@/components/tabs/TabNavigation";
import Tiptap from "@/components/TipTap/TipTap";
import Button from "@/components/buttons/Button";
import InertiaLink from "@/components/buttons/InertiaLink";
import { Artwork } from "@/components/ArtworkSlot";
import buildTrackTabs from "../trackTabs";
import FormActions from "@/components/buttons/FormActions";

interface LyricsEditProps {
  track: {
    id: number;
    title: string;
    artwork_attached: boolean;
  };
  artwork: Artwork;
  lyrics_body: object | null;
  lyric_section_kinds: string[];
}

const Edit: React.FC<LyricsEditProps> = ({
  track,
  artwork,
  lyrics_body,
  lyric_section_kinds,
}) => {
  const { data, setData, put, processing, transform } = useForm({
    lyrics_body: lyrics_body ?? {},
  });

  transform((data) => ({ track: { lyrics_body: data.lyrics_body } }));

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    put(`/tracks/${track.id}/lyrics`);
  };

  const handleEditorContentChange = (content: any) => {
    setData("lyrics_body", content);
  };

  return (
    <div className="flex w-full flex-col items-start justify-start gap-5 md:gap-10">
      <PageHeader
        backLink={{
          href: `/tracks/${track.id}/lyrics`,
          text: "Back to lyrics",
        }}
        title={`Edit ${track.title} Lyrics`}
        secondaryAction={{
          href: `/tracks/${track.id}/lyrics`,
          text: "Cancel",
        }}
        artwork={{
          trackId: track.id,
          uploaded: track.artwork_attached,
          thumbnailUrl: artwork.thumbnail_url,
          originalUrl: artwork.original_url,
          alt: `${track.title} artwork`,
        }}
      />
      <TabNavigation tabs={buildTrackTabs(track.id, "lyrics")} />
      <form
        onSubmit={handleSubmit}
        className="flex w-full flex-col gap-5 md:gap-10"
      >
        <Tiptap
          content={data.lyrics_body as JSON}
          setEditorContent={handleEditorContentChange}
          initialiseAsEditable={true}
          lyricSectionKinds={lyric_section_kinds}
        />
        <FormActions>
          <InertiaLink
            href={`/tracks/${track.id}/lyrics`}
            type="secondary"
            text="Cancel"
          />
          <Button
            text={processing ? "Saving..." : "Save"}
            type="primary"
            htmlButtonType="submit"
            disabled={processing}
          />
        </FormActions>
      </form>
    </div>
  );
};

export default Edit;
